/**
 * El circuito completo de un documento: todos sus requerimientos vigentes.
 *
 * Es la unidad que se abre desde la **insignia de estado** del documento, y el
 * motivo de que exista separada es que se usa desde dos sitios: la fila de
 * `/expediente/:id` y —una por documento— el panel de la sección en
 * `/bloque/:periodo`.
 *
 * Por qué el disparador es la insignia de estado y no un chip aparte: «En
 * verificación» o «Verificado» es la **conclusión**, y el circuito es cómo se
 * llegó a ella. Poner lo segundo detrás de lo primero es lo que hace Recuperos
 * —`trigger={<EstadoNotificacionBadge req={req} />}`— y evita inventar un
 * indicador nuevo que haya que aprenderse.
 */
import type { DocumentoDeclarado } from '../api/tipos.js'
import { SeguimientoDeConsulta } from './SeguimientoDeConsulta.js'

export function SeguimientoDeDocumento({
  documento,
  cabecera,
}: {
  documento: DocumentoDeclarado
  /**
   * Título del documento dentro del panel.
   *
   * Va cuando el panel cubre VARIOS documentos —el de la sección— y hay que
   * poder distinguirlos. Desde la fila del expediente sobra: el nombre del
   * documento está en la misma fila, a dos centímetros del puntero.
   */
  cabecera?: boolean
}) {
  // `NEG-15`: los anulados no consumen ordinal y no son el recorrido vigente.
  const vigentes = documento.requerimientos.filter((requerimiento) => !requerimiento.anulada)

  return (
    <div className="sigfisc-circuito__documento">
      {cabecera === true && (
        <p className="sigfisc-circuito__documento-nombre">{documento.denominacion}</p>
      )}

      {vigentes.length === 0 ? (
        <p className="sigfisc-circuito__vacio">
          Este documento aún no se ha requerido, así que todavía no hay circuito que mostrar.
        </p>
      ) : (
        vigentes.map((requerimiento) => (
          <SeguimientoDeConsulta key={requerimiento.id} requerimiento={requerimiento} />
        ))
      )}
    </div>
  )
}
